import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Card,
  Checkbox,
  Collapse,
  Fade,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import DatatableComponent from "helpers/DatatableComponent";
import DeleteDialog from "helpers/DeleteDialog";
import FormDialog from "helpers/FormDialog";
import { connect } from "react-redux";
import { mapStateToProps } from "store/helpers/mapState";
import { mapDispatchToProps } from "store/helpers/mapDispatch";
import { ListAlt, MenuOpen } from "@mui/icons-material";
import { errorToast } from "helpers/Notification";
import { getError } from "store/helpers/common_functions";
import BasicMenu from "helpers/menu";
import PermissionList from "./PermissionList";
import TabBoxComponent from "components/UI/TabBox";
import TabPanel from "helpers/TabPanel";

const ExpandedRows = (props) => {
  const { permittedMenu, handleChange, menus, parent, handleDelete } = props;
  const [openAction, setOpenAction] = React.useState(false);
  const [code, setCode] = React.useState(0);
  const list = menus?.filter((item) => item?.parentId === parent?.menuId);

  return (
    <>
      {list?.map((row, key) => {
        const menuExist = permittedMenu?.find(
          (item) => item?.menuId === row?.menuId
        );

        // permittedMenu={parent?.subMenus}
        const actionList = menus?.filter(
          (item) => item?.parentId === row?.menuId
        );

        return (
          <>
            <TableRow key={row.id}>
              <TableCell align="right" component="th" scope="row" colSpan={2}>
                <MenuOpen />
              </TableCell>
              <TableCell>{row.code}</TableCell>
              <TableCell>{row.name}</TableCell>
              <TableCell>{row.type}</TableCell>
              <TableCell>
                {" "}
                <div className="text-bold">
                  <input
                    checked={menuExist?.create}
                    type="checkbox"
                    onChange={(e) =>
                      handleChange({
                        create: e.target.checked,
                        menuId: row?.id,
                      })
                    }
                  />
                </div>
              </TableCell>
              <TableCell>
                {" "}
                <div className="text-bold">
                  <input
                    checked={menuExist?.read}
                    type="checkbox"
                    onChange={(e) =>
                      handleChange({
                        read: e.target.checked,
                        menuId: row?.id,
                      })
                    }
                  />
                </div>
              </TableCell>
              <TableCell>
                {" "}
                <div className="text-bold">
                  <input
                    checked={menuExist?.update}
                    type="checkbox"
                    onChange={(e) =>
                      handleChange({
                        update: e.target.checked,
                        menuId: row?.id,
                      })
                    }
                  />
                </div>
              </TableCell>
              <TableCell>
                {" "}
                <div className="text-bold">
                  <input
                    checked={menuExist?.delete}
                    type="checkbox"
                    onChange={(e) =>
                      handleChange({
                        delete: e.target.checked,
                        menuId: row?.id,
                      })
                    }
                  />
                </div>
              </TableCell>
              <TableCell>
                <BasicMenu
                  onDelete={() => handleDelete(row?.id)}
                  onDetails={() => {
                    setCode(row.code);
                    setOpenAction(true);
                  }}
                  detailsName="Actions"
                />
              </TableCell>
            </TableRow>
            {actionList?.map((action) => {
              const actionExist = menuExist?.actions?.find(
                (item) => item?.menuId === action?.menuId
              );
              return (
                <TableRow
                  key={action.code}
                  sx={{
                    display:
                      code === row.code && openAction ? "table-row" : "none",
                  }}
                >
                  <TableCell
                    align="right"
                    component="th"
                    scope="row"
                    colSpan={2}
                  >
                    <ListAlt />
                  </TableCell>
                  <TableCell>{action.code}</TableCell>
                  <TableCell>{action.name}</TableCell>
                  <TableCell component="th" scope="row" colSpan={2}>
                    {action.type}
                  </TableCell>
                  <TableCell component="th" scope="row" colSpan={3}>
                    {" "}
                    <div className="text-bold">
                      <input
                        checked={actionExist?.read}
                        type="checkbox"
                        disabled={!menuExist?.read}
                        onChange={(e) =>
                          handleChange({
                            read: e.target.checked,
                            menuId: action?.id,
                          })
                        }
                      />
                    </div>
                  </TableCell>
                  <TableCell>
                    <BasicMenu onDelete={() => handleDelete(action?.id)} />
                  </TableCell>
                </TableRow>
              );
            })}
          </>
        );
      })}
    </>
  );
};

const UserPermission = (props) => {
  const { menus, location, PutAction } = props;

  const userId = location.state?.userId;

  const [tabValue, setTabValue] = React.useState(location?.state?.tab ?? 0);

  const handleChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <div className="w-full mb-12 px-4">
      <Card>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <TabBoxComponent
            selectedValue={tabValue}
            handleTabChange={handleChange}
            tabList={[
              {
                label: "Menus",
                tabValue: 0,
              },
              {
                label: "Actions",
                tabValue: 1,
              },
            ]}
          />

          <TabPanel index={0} value={tabValue} p={0}>
            <PermissionList
              category={"menu"}
              menus={menus}
              location={location}
              PutAction={PutAction}
            />
          </TabPanel>
          <TabPanel index={1} value={tabValue} p={0}>
            <PermissionList
              category={"action"}
              menus={menus}
              location={location}
              PutAction={PutAction}
            />
          </TabPanel>
        </Box>
      </Card>
    </div>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(UserPermission);
